<template>
  <div :class="{ 'margin-top-2': isGroupOrderTier }">
    <div
      class="banner-info flex items-center justify-between"
      :style="customStyles"
    >
      <p class="banner-info__text">
        <strong>{{ title || 'Tier Header' }}</strong>
      </p>
      <button @click="$emit('onRemoveTier')">
        <img
          v-if="!disabled"
          class="remove-icon w-4"
          src="@/assets/trash.svg"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupOrderTierHeader',
  props: {
    title: {
      required: true,
      type: String
    },
    disabled: {
      required: true,
      type: Boolean
    },
    isGroupOrderTier: {
      required: false,
      default: true,
      type: Boolean
    },
    customStyles: {
      required: false,
      default: '',
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-header {
  .editorial {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.838rem;
  }
}
.banner-actions-holder {
  border-bottom: 1px solid #dfdad2;
  .banner-action {
    p {
      font-size: 0.838rem;
    }
  }
}
.banner-info {
  margin-top: 0.5rem;
  background-color: #dfdad2;
  padding: 1rem 1.66rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }
  .banner-info__text {
    font-size: 0.913rem;
  }
}
</style>
